module.exports = __webpack_public_path__ + "img/arcserve-udp.126146a8.webp";